<template>
  <v-container fluid class="max-width">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Approved Requisitions</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12">
            <!-- start of table -->
            <v-data-table :headers="headers" :items="recordsData" :search="search">
              <!-- action template -->
              <template v-slot:item.consumables="{ item }">
                <v-btn
                  color="accent"
                  text
                  :to="`/requisitions-preview/${item.project.id}/${item.phase}`"
                >
                  <v-icon left>mdi-eye</v-icon>Preview / Print
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.status>
                <span style="color: #16b1ff; font-weight: bold;">Approved</span>
              </template>
              <!-- end -->

              <!-- date template -->
              <template v-slot:item.startDate="{ item }">{{ item.project.startDate | date }}</template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Project Title", value: "project.name" },
      { text: "Scale", value: "project.projectScale.Name" },
      { text: "Project Lead", value: "project.lead.name" },
      { text: "Start Date", value: "startDate" },
      { text: "Start Time", value: "project.startTime" },
      { text: "Phase", value: "phase" },
      { text: "Status", value: "status" },
      { text: "Consumables", value: "consumables" }
    ],
    recordsData: []
  }),
  methods: {
    getApprovals() {
      const self = this;
      this.$store
        .dispatch("get", `/approved-requisitions`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.recordsData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getApprovals();
  }
};
</script>